import { render, staticRenderFns } from "./TrainingQuizQuestionTypeSimple.vue?vue&type=template&id=44bb00d6&"
import script from "./TrainingQuizQuestionTypeSimple.vue?vue&type=script&lang=js&"
export * from "./TrainingQuizQuestionTypeSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports